import {
  SEARCH_AREA_ACTIVE_SUGGESTION_CLASS,
  SEARCH_AREA_SUGGESTION_INDEX_ATTRIBUTE,
  SEARCH_AREA_SUGGESTION_SELECTOR,
} from "./constants";
import { formatLocationLabel } from "./formatLocationLabel";

export const clearSuggestions = (suggestionsContainer: HTMLDivElement) => {
  suggestionsContainer.innerHTML = "";
  suggestionsContainer.classList.add("hidden");
};

export const renderSuggestions = (
  suggestionsContainer: HTMLDivElement,
  suggestions: google.maps.places.AutocompletePrediction[]
) => {
  if (suggestions.length === 0) {
    clearSuggestions(suggestionsContainer);
    return;
  }

  suggestionsContainer.innerHTML = suggestions
    .map(
      (suggestion, index) => `
        <button
          type="button"
          class="search-area-input__suggestion"
          ${SEARCH_AREA_SUGGESTION_INDEX_ATTRIBUTE}="${index}"
        >
          ${formatLocationLabel(suggestion.description)}
        </button>
      `
    )
    .join("");

  suggestionsContainer.classList.remove("hidden");
};

export const updateHighlightedSuggestion = (
  suggestionsContainer: HTMLDivElement,
  activeSuggestionIndex: number
) => {
  const suggestionElements = suggestionsContainer.querySelectorAll<HTMLElement>(
    SEARCH_AREA_SUGGESTION_SELECTOR
  );

  suggestionElements.forEach((suggestionElement, index) => {
    suggestionElement.classList.toggle(
      SEARCH_AREA_ACTIVE_SUGGESTION_CLASS,
      index === activeSuggestionIndex
    );
  });
};

export const getClickedSuggestionIndex = (
  target: EventTarget | null
): number | null => {
  const suggestionElement = (target as HTMLElement | null)?.closest(
    `[${SEARCH_AREA_SUGGESTION_INDEX_ATTRIBUTE}]`
  ) as HTMLElement | null;

  if (!suggestionElement) {
    return null;
  }

  const suggestionIndex = Number.parseInt(
    suggestionElement.dataset.searchAreaSuggestionIndex || "-1",
    10
  );

  return Number.isNaN(suggestionIndex) ? null : suggestionIndex;
};
